import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import { AssociateService } from '../../associate/shared/services/associate.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { Sort, PageEvent, MatPaginator, MatSelect } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DeletePopupComponent } from '../../organization/Popups/delete-popup/delete-popup.component';
import { MatSnackBar, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../../shared/services/auth/auth.service';
import { ToastService } from '../../shared/services/toast.service'
import { element } from 'protractor';
import { NotificationService } from '../../shared/services/notification.service';
import { EmailPopupComponent } from '../../shared/components/email-popup/email-popup.component';
import { ProxyUsersPopupComponent } from '../../shared/components/proxy-users-popup/proxy-users-popup.component';
import { OrganizationService } from '../../shared/services/organization.service';
import { AssessmentsService } from '../../shared/services/assessments.service';
import { ChangePasswordPopupComponent } from '../../shared/components/change-password-popup/change-password-popup.component';
import { Configuration } from '../../app.constants';
import { HrTeamPopUpComponent } from '../hr-team-pop-up/hr-team-pop-up.component';

@Component({
    selector: 'app-back-office',
    templateUrl: './back-office.component.html',
    styleUrls: ['./back-office.component.css']
})
export class BackOfficeComponent implements OnInit {
    public isAdmin: Boolean = false;
    public isLoading: Boolean = false;
    // select All
    public selectAll: Boolean = false;
    public numberOfSelectedAssociates = 0;
    public numberOfAllSelectedAssociates = 0;
    public bulkOperationAssociates = {};
    public bulkOperationUserIds = []
    public bulkOperationEmails = []
    public assessId: any;
    public editableAssocaite: any = { _id: '' };
    public assessmentDetails: any = false;
    public isAssessmentsOn = true;
    public associatesList = [];
    public associatesStats: any;
    public query: any;
    public assessStatusToggle: Boolean;
    public search: any = {
        normalAssoc: true,
        highPotAssoc: true,
        job: '',
        name: '',
        organization: '',
        mobility: '',
        selectedItems: [] ,
        role: {$in: ['Vendor Admin', 'Vendor Manager', 'Admin', 'Super Admin', 'Product Manager', 'Product Admin','Guest']}
    };
    public staticDDlist: any;
    public filter: Boolean = false;
    public roleEdit: Boolean = false;
    public previousAssociateRole;
    public organizations = [];

    length = 3;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 100];

    pageEvent: PageEvent;
    options = [
    { value: 'data2u', label: 'Data2U' },
    { value: 'emts', label: 'EMTS' },
    { value: 'volumetric-validator', label: 'Volumetric Validator' }
  ];

    @ViewChild(MatPaginator) paginator: MatPaginator
    public serverApiUrl;


closeDropdownOnSelect(selectRef: MatSelect) {
    // We wait a tiny moment (0ms) to ensure the selection update happens first, 
    // then close the panel.
    setTimeout(() => {
      selectRef.close();
    }, 0);
  }
    constructor(
        public dialog: MatDialog,
        public mobileNav: MobileNavService,
        public route: ActivatedRoute,
        public router: Router,
        public associateService: AssociateService,
        public staticValueService: StaticValueService,
        public tosterService: ToastService,
        public AssessmentsServiceObj: AssessmentsService,
        public notificationService: NotificationService,
        public authService: AuthService,
        public organizationService: OrganizationService,
        public config: Configuration) {
        console.log(this.staticValueService)
        this.staticDDlist = this.staticValueService.staticData.staticDD;
    }

    onClickMe() {
        this.mobileNav.showSideNav();
    }

    editAssessment() {
        this.router.navigate(['/home/talent-management/editassessment', this.assessId]);
    }

    ngOnInit() {
        this.serverApiUrl = this.config.StaticImageUrl;
        this.checkIfAssessmentsOn();

        this.organizationService.getOrganization().subscribe((data) => {
            this.organizations = Object.assign([], data);
        }, (error) => { });

        if (this.authService.user.role === 'Admin') {
            this.isAdmin = true;
        }
        this.query = {
            search: {
                'active': true,
                'user_isActive': true,
                'role': { $in: ['Vendor Admin', 'Vendor Manager', 'Admin', 'Super Admin', 'Product Manager', 'Product Admin', 'Guest']}
                //   'jobDescription.jobCategory': { $regex: '', $options: 'i' },
                //   'role': { $regex: '', $options: 'i' },
                //   'mobilityPreference.mobilityLocation': { $regex: '', $options: 'i' },
                //   'personalInformation.fullName': { $regex: '', $options: 'i' }
            },
            sort: { 'personalInformation.fullName': 1 },
            pagination: {
                pageIndex: 0,
                pageSize: this.pageSize
            }
        };

        this.search = {
            normalAssoc: true,
            highPotAssoc: true,
            organization: '',
            job: '',
            name: '',
            mobility: '',
            role: { $in: ['Vendor Admin', 'Vendor Manager', 'Admin', 'Super Admin', 'Product Manager', 'Product Admin', 'Guest']}
        };
        this.getAssociates();
    }

    getServerData(event) {
        this.query.pagination.pageIndex = event.pageIndex;
        this.query.pagination.pageSize = event.pageSize;
        this.getAssociates();
    }

    setPageSizeOptions(setPageSizeOptionsInput: string) {
        this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
    }

    sortData(sort: Sort) {
        this.query.sort = {};
        if (sort.direction === 'asc') {
            this.query.sort[sort.active] = -1;
        } else if (sort.direction === 'desc') {
            this.query.sort[sort.active] = 1;
        }
        this.getAssociates();
    }

    onChange() {
        this.selectAll = false;
        this.numberOfAllSelectedAssociates = 0;
        this.numberOfSelectedAssociates = 0;
        this.bulkOperationAssociates = Object.assign({}, {});
        this.bulkOperationUserIds = [];
        this.query.search['user_isActive'] = !this.filter;
        if (this.search.job) {
            this.query.search['jobDescription.jobCategory'] = this.search.job;
        } else {
            delete this.query.search['jobDescription.jobCategory'];
        }
        if (this.search.role) {
            this.query.search['role'] = this.search.role;
        } else {
            // delete this.query.search['role'];
             this.query.search['role'] = { $in: ['Vendor Admin', 'Vendor Manager', 'Admin', 'Super Admin', 'Product Manager', 'Product Admin','Guest']};
            // this.query.search['role'] = {$in: ['Vendor Admin', 'Vendor Manager', 'Admin', 'Super Admin']};
        }
        if (this.search.mobility) {
            this.query.search['mobilityPreference.mobilityLocation'] = this.search.mobility;
        } else {
            delete this.query.search['mobilityPreference.mobilityLocation'];
        }
        if (this.search.organization) {
            this.query.search['jobDescription.company.id'] = this.search.organization;
        } else {
            delete this.query.search['jobDescription.company.id'];
        }
        if (this.search.name) {
            this.query.search['personalInformation.fullName'] = { $regex: this.search.name, $options: 'i' };
        } else {
            delete this.query.search['personalInformation.fullName'];
        }
        if (this.search.highPotAssoc && !this.search.normalAssoc) {
            this.query.search['isHighPotential'] = true;
            delete this.query.search['$or'];
        } else if (!this.search.highPotAssoc && this.search.normalAssoc) {
            this.query.search['$or'] = [{ isHighPotential: { $exists: false } }, { isHighPotential: false }];
            delete this.query.search['isHighPotential'];
        } else {
            delete this.query.search['isHighPotential'];
            delete this.query.search['$or'];
        }

        // reset pagination pageindex to 0
        this.paginator.pageIndex = 0;
        this.getAssociates();
    }

    getAssociates() {
        this.isLoading = true;
        this.associateService.search(
            this.query.pagination.pageIndex,
            this.query.pagination.pageSize,
            this.query.search,
            this.query.sort)
            .then((data) => {
                this.isLoading = false;
                if (data) {
                    this.associatesList = Object.assign([], data['data']);
                    console.log("this.associatesList ", this.associatesList);
                }
                this.numberOfAllSelectedAssociates = data['numberOfSelectedAssociates'];
                this.length = this.numberOfAllSelectedAssociates;
            }, (err) => {
                this.isLoading = false;
            });
    }

    
    // Function to handle changes for the "Has Access" dropdown filter
    // onHasAccessChange() {
    //     this.filterDataBasedOnAccess(this.search.selectedItems);
    // }

    // Function to apply filtering based on the selected 'Has Access' values
    // filterDataBasedOnAccess(selectedItems: string[]) {
    //     if (selectedItems.includes('data2u') && selectedItems.includes('emts')) {
    //     console.log('Both Data2U and EMTS are selected');
    //     // Add your custom logic here
    //     } else if (selectedItems.includes('data2u')) {
    //     console.log('Only Data2U is selected');
    //     // Add your custom logic here
    //     } else if (selectedItems.includes('emts')) {
    //     console.log('Only EMTS is selected');
    //     // Add your custom logic here
    //     } else {
    //     console.log('No options selected');
    //     // Handle case when no options are selected
    //     }
    // }

    grantAccessToSelectedUsers() {
        const selectedIds = Object.keys(this.bulkOperationAssociates); 
        if (!selectedIds || selectedIds.length === 0) {
            this.tosterService.warning("Please select at least one user first.");
            return;
        }

        const selectedValues = this.search.selectedItems;  

        this.associateService.assignAccessLevelToAssociate(selectedIds, selectedValues)
            .subscribe(
                response => {
                    this.tosterService.success();
                    const userRaw = localStorage.getItem('user');
                    if (userRaw) {
                        const user = JSON.parse(userRaw);
                        user.hasAccess = response && response.hasAccess ? response.hasAccess : (Array.isArray(selectedValues) ? selectedValues : []);
                        localStorage.setItem('user', JSON.stringify(user));
                    }
                },
                error => {
                    this.tosterService.error("Error granting access");
                    console.error('Error granting access:', error);
                }
            );
    }

 updateAssociateAccess(associate: any, selectRef: MatSelect) {
    const associateId = associate._id;
    const newAccessLevels = associate.hasAccesses;

    if (!associateId) {
        this.tosterService.error("Associate ID is missing.");
        selectRef.close();
        return;
    }
    
    this.associateService.assignAccessLevelToAssociate([associateId], newAccessLevels)
        .subscribe(
            (response: any) => {
                associate.hasAccesses = response && response.hasAccess ? response.hasAccess : newAccessLevels;
                this.tosterService.success();
                this.getAssociates();
            },
            (error: any) => {
                this.tosterService.error("Error updating access.");
                console.error('Error updating access:', error);
            }
        );
    setTimeout(() => {
        selectRef.close();
    }, 0);
}


    existsInBulkOperations(_id) {
        return _id in this.bulkOperationAssociates;
    }

    // open dialog for bulk archive
    openDialog(id?, fName?, lName?): void {
        const fullName = fName + ' ' + lName;

        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: { title: `Are you sure you want to ${this.filter ? 'give' : 'revoke'} ${(this.numberOfSelectedAssociates > 1 || this.selectAll) ? 'selected associates' : fullName} access ${this.filter ? 'to' : 'from'} the system?` }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === 'Proceed') {
                if (this.filter) {
                    this.giveAccess(id);
                } else {
                    this.accessRevoke(id);
                }
            }
        });
    }

    changePassword(associate) {
        const dialogRef = this.dialog.open(ChangePasswordPopupComponent, {
            width: '400px',
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result !== 'Cancel') {
                // tslint:disable-next-line:max-line-length
                this.authService.changePassword({ username: result.username, password: result.password, userId: associate.user_id }).subscribe(data => {
                    this.tosterService.success();
                }, err => {
                    this.tosterService.error('Username not updated');
                    console.log(err);
                });
            }
        });
    }

    changeHighPotential(associate, highPotential) {
        // if(this.isAssessmentsOn && !highPotential){
        //     this.tosterService.error('People cannot be removed from assessment after its started');
        //     return;
        // }
        if(this.isAssessmentsOn && highPotential){
            const dialogRef = this.dialog.open(AddPersonToAssessmentComponent, {
                width: '400px',
                data: {}
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.AssessmentsServiceObj.changeHighPotential(associate._id, highPotential).then(res => {
                        associate.isHighPotential = highPotential;
                    }).catch(err => {
                        console.log(err);
                    });
                }
              });
        } else {
            this.AssessmentsServiceObj.changeHighPotential(associate._id, highPotential).then(res => {
                associate.isHighPotential = highPotential;
            }).catch(err => {
                console.log(err);
            });
        }
    }

    // functions for multi select functionality

    multiSelectChange(event, _id, userId, email) {
        if (this.selectAll) {
            this.selectAll = !this.selectAll;
        }
        if (event.target.checked === true) {
            this.bulkOperationEmails.push(email);
            this.bulkOperationAssociates[_id] = _id;

            if (this.length === Object.keys(this.bulkOperationAssociates).length) {
                this.selectAll = true;
            }

            if (userId) {
                this.bulkOperationUserIds.push(userId)
            }
        } else if (_id in this.bulkOperationAssociates) {
            delete this.bulkOperationAssociates[_id];
            this.bulkOperationUserIds.splice(this.bulkOperationUserIds.indexOf(userId), 1);
            this.bulkOperationEmails.splice(this.bulkOperationEmails.indexOf(email), 1);
        }

        this.selectedAssociateNumber();
    }


    // length of selected Organizations
    selectedAssociateNumber() {
        this.numberOfSelectedAssociates = Object.keys(this.bulkOperationAssociates).length;

    }
    // select All associates
    selectAllChange(event) {
        this.selectAll = event.target.checked;
        if (event.target.checked === true) {
            //   this.numberOfSelectedAssociates = this.bulkOperationUserIds.length;
            console.log(this.query)
            this.associateService.getUserIdsAndEmails(this.query).subscribe(data => {
                console.log(data)
                Object.assign([], data['data']).forEach(data1 => {
                    console.log(data1['_id'] in this.bulkOperationAssociates)
                    if (!(data1['_id'] in this.bulkOperationAssociates)) {
                        this.numberOfSelectedAssociates++;
                        this.bulkOperationUserIds.push(data1.user_id);
                        this.bulkOperationEmails.push(data1.workContactDetails.workEmail)
                        this.bulkOperationAssociates[data1._id] = data1['_id'];
                    }
                });
            })
            //   this.associatesList.forEach(element => {
            //       this.bulkOperationUserIds.push(element.user_id);
            //       this.bulkOperationEmails.push(element.workContactDetails.workEmail)
            //       this.bulkOperationAssociates[element._id] = element._id;
            //     })
        } else if (event.target.checked === false) {
            this.numberOfSelectedAssociates = 0;
            this.bulkOperationUserIds = [];
            this.bulkOperationEmails = [];
            this.bulkOperationAssociates = Object.assign({}, {});
        }
    }
    sendEmails(email?, userId?) {
        console.log('email', email, userId)
        const dialogRef = this.dialog.open(DeletePopupComponent, {
            width: '400px',
            data: {
                title: `You want to send Welcome ${this.bulkOperationEmails.length === 0 ? 'Email' : 'Emails to selected associates'}?`,
                email: true,
            }
        });
        // const dialogRef = this.dialog.open(EmailPopupComponent, {
        //     width: '500px',
        //     });
        dialogRef.afterClosed().subscribe(response => {
            if (response === 'Proceed') {
                this.notificationService.sendWelcomeEmail(email ? [email] : this.bulkOperationEmails, userId ? [userId] : this.bulkOperationUserIds)
                    .then(res => {
                    }).catch(err => {
                    });
            }
        })
    }

    accessRevoke(id?) {
        this.associateService.revokeLoginAccess(id ? [id] : this.bulkOperationUserIds).subscribe(res => {
            this.getAssociates();
            this.numberOfSelectedAssociates = 0;
            this.bulkOperationUserIds = [];
            this.bulkOperationAssociates = {};
            this.tosterService.success();
        }, err => { });
    }

    giveAccess(id?) {
        this.associateService.giveLoginAccess(id ? [id] : this.bulkOperationUserIds).subscribe(res => {
            this.getAssociates();
            this.tosterService.success();
            this.numberOfSelectedAssociates = 0;
            this.bulkOperationUserIds = [];
            this.bulkOperationAssociates = {};
        }, err => {
        });
    }

    editRole(associate) {
        this.editableAssocaite = JSON.parse(JSON.stringify(associate));
        this.previousAssociateRole = associate.role;
    }
    saveRole(associate) {
        associate.role = this.editableAssocaite.role;
        this.associateService.updateAssociate(associate).subscribe(res => {
            this.tosterService.success();
            this.editableAssocaite._id = '';
        }, err => { });
    }

    proxyUserPopUp(associate) {
        const dialogRef = this.dialog.open(ProxyUsersPopupComponent, {
            width: '650px',
            data: { associate: associate }
        });

        dialogRef.afterClosed().subscribe(res => {
            this.associateService.updateAssociate(associate).subscribe(data => { })
        });
    }

    startAssessments() {
        const dialogRef = this.dialog.open(AssessmentAddEditDialogComponent, {
            width: '600px',
            data: {}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result[0]) {
                this.AssessmentsServiceObj.addNewAssessmentSession(result[1]).then(res => {
                    this.checkIfAssessmentsOn();
                }).catch(err => {
                    console.log(err);
                });
            }
        });
    }

    checkIfAssessmentsOn() {
        this.AssessmentsServiceObj.isAssessmentsOn().then(res => {
            if (res['isAssessmentOn']) {
                this.isAssessmentsOn = true;
            } else {
                this.isAssessmentsOn = false;
            }
            if (res['details']) {
                this.assessmentDetails = res['details'];
                this.assessStatusToggle = this.assessmentDetails.isActive;
                this.assessId = this.assessmentDetails._id;
            }
        }).catch(err => {
            console.log(err);
        });
    }

    assessStatusToggled() {
        console.log(this.assessStatusToggle);
        this.AssessmentsServiceObj.toggleAssessmentStatus(this.assessStatusToggle, this.assessId).then(res => {
            this.checkIfAssessmentsOn();
        }).catch(err => {
            console.log(err);
        })
    }

    openHRTeamPopup(associate) {
        const dialogRef = this.dialog.open(HrTeamPopUpComponent, {
            width: '650px',
            panelClass: 'hr-team-dialog',
            data: { associate: associate }
        });

        dialogRef.afterClosed().subscribe(res => {
            console.log('Pop up closed');
        });
    }

}


@Component({
    selector: 'app-assess-add-edit-dialog',
    template: `
    <div class="text-center">
    <div><span class="mdi mdi-search-in-file font-60 blue-text" style="color: #4285f4;"></span></div>
    <h3 translate="" ng-reflect-translate="">Assessment</h3>
    <mat-dialog-content>
    <div class="row" style="    padding: 10px;">
        <div class="col-xs-4 text-left">
            <p style=" font-weight:500; margin-top: 14px;
            margin-bottom: 0px;">Profile Review</p>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.profileReviewStart" placeholder="Start Date" matInput [matDatepicker]="profileReviewStart" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="profileReviewStart"></mat-datepicker-toggle><mat-datepicker #profileReviewStart></mat-datepicker>
                </span>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.profileReviewEnd" matInput placeholder="End Date" [matDatepicker]="profileReviewEnd" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="profileReviewEnd"></mat-datepicker-toggle><mat-datepicker #profileReviewEnd></mat-datepicker>
                </span>
            </div>
        </div>
    </div>
    <div class="row" style="    padding: 10px;">
        <div class="col-xs-4 text-left">
            <p style=" font-weight:500; margin-top: 14px;
            margin-bottom: 0px;">Assessment/Plans</p>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.assessmentStart" placeholder="Start Date" matInput [matDatepicker]="assessmentStart" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="assessmentStart"></mat-datepicker-toggle><mat-datepicker #assessmentStart></mat-datepicker>
                </span>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.assessmentEnd" matInput placeholder="End Date" [matDatepicker]="assessmentEnd" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="assessmentEnd"></mat-datepicker-toggle><mat-datepicker #assessmentEnd></mat-datepicker>
                </span>
            </div>
        </div>
    </div>
    <div class="row" style="    padding: 10px;">
        <div class="col-xs-4 text-left">
            <p style=" font-weight:500; margin-top: 14px;
            margin-bottom: 0px;">Calibration</p>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.calibrationStart" placeholder="Start Date" matInput [matDatepicker]="calibrationStart" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="calibrationStart"></mat-datepicker-toggle><mat-datepicker #calibrationStart></mat-datepicker>
                </span>
            </div>
        </div>
        <div class="col-xs-4">
            <div class="input-group text-left" style="display: flex; margin-top: 10px;">
                <input [(ngModel)]="filter.calibrationEnd" matInput placeholder="End Date" [matDatepicker]="calibrationEnd" type="text" class="form-control input-xs">
                <span class="calIcon">
                    <mat-datepicker-toggle matSuffix [for]="calibrationEnd"></mat-datepicker-toggle><mat-datepicker #calibrationEnd></mat-datepicker>
                </span>
            </div>
        </div>
    </div>
    <div class="row" style="    padding: 10px;">
        <div class="col-xs-4 text-left">
            <p style="font-weight:500; margin-top: 8px;
            margin-bottom: 0px;">Status</p>
        </div>
        <div class="col-xs-8 text-left">
            <div class="be-radio inline">
                <input type="radio" [(ngModel)]='filter.status' [value]="false" name="Off" id="Off">
                <label for="Off" class="mg-rt" translate>Off</label>
            </div>
            <div class="be-radio inline" >
                <input type="radio" [(ngModel)]='filter.status' [value]="true" name="On" id="On">
                <label for="On" class="mg-rt" translate>On</label>
            </div>
        </div>
    </div>
    </mat-dialog-content>
    <mat-dialog-actions style="display: block;">
        <button class="btn btn-space btn-default" mat-dialog-close>Cancel</button>
        <button class="btn btn-space btn-primary" (click)="proceed()">Proceed</button>
    </mat-dialog-actions>
    </div>
    `,
    styles: [
        `.calIcon {
            position: absolute !important;
            right: 0px !important;
            z-index: 10 !important;
            top: -5px !important;
            color: #4285f4;
        }`
    ]
})
export class AssessmentAddEditDialogComponent {
    filter = {
        profileReviewStart: null,
        profileReviewEnd: null,
        assessmentStart: null,
        assessmentEnd: null,
        calibrationStart: null,
        calibrationEnd: null,
        status: true
    };
    constructor(
        public dialogRef: MatDialogRef<AssessmentAddEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }
    onNoClick(): void {
        this.dialogRef.close([false, this.filter]);
    }

    proceed() {
        this.dialogRef.close([true, this.filter]);
    }
}

@Component({
    selector: 'app-add-to-assessment-dialog',
    template: `
    <div class="text-center">
    <div><span class="mdi mdi-search-in-file font-60 blue-text" style="color: #4285f4;"></span></div>
    <h3 translate="" ng-reflect-translate="">Add to Current Assessment</h3>
    <mat-dialog-content>
    Add Associate to current assessment campaign and send email to Associate's Line Manager.
    </mat-dialog-content>
    <mat-dialog-actions style="display: block;">
        <button class="btn btn-space btn-default" mat-dialog-close>Cancel</button>
        <button class="btn btn-space btn-primary" (click)="proceed()">Proceed</button>
    </mat-dialog-actions>
    </div>
    `
})
export class AddPersonToAssessmentComponent {
    filter = {
        startDate: new Date(),
        endDate: new Date(),
        status: true
    };
    constructor(
        public dialogRef: MatDialogRef<AddPersonToAssessmentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) { }
    onNoClick(): void {
        this.dialogRef.close([false, this.filter]);
    }

    proceed() {
        this.dialogRef.close([true, this.filter]);
    }
}
